import { NgTemplateOutlet } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  contentChild,
  inject,
  input,
  TemplateRef,
} from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'

import { UserFacade } from '~/core/features'
import { EGuardSection } from '~/core/models'

import { NotGrantedBlockComponent } from '../not-granted-block/not-granted-block.component'

@Component({
  selector: 'app-user-section-access',
  templateUrl: './user-section-access.component.html',
  styleUrl: './user-section-access.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, NotGrantedBlockComponent],
})
export class UserSectionAccessComponent {
  private readonly userFacade = inject(UserFacade)
  private readonly permissionSections = toSignal(this.userFacade.permissionSections$)

  readonly template = contentChild(TemplateRef)

  readonly sectionName = input<EGuardSection | null | undefined>(null)

  readonly isGranted = computed(() =>
    this.checkIsGranted(this.permissionSections(), this.sectionName())
  )

  constructor() {}

  checkIsGranted(
    permissionSections: { [key: string]: boolean | undefined } | null | undefined,
    grantedSectionName: EGuardSection | null | undefined
  ): boolean {
    if (!permissionSections || !grantedSectionName) {
      return false
    } else if (permissionSections[grantedSectionName]) {
      return true
    } else {
      return false
    }
  }
}
